export default {
      id: "colon-usage",
      viewBox: "0 0 83.097 80",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#colon",
      toString: function () {
        return this.url;
      }
    }